// @ts-nocheck
/** Module form fields — alpha/underscore/space allow-list on name input. */
import { Input } from '@/components/ui/input';

const Star = () => <span className="ml-0.5 text-destructive">*</span>;

function Field({ label, children, error }: any) {
  return (
    <div className="space-y-1.5">
      <label className="text-sm font-medium text-foreground">
        {label} <Star />
      </label>
      {children}
      {error ? <div className="text-xs text-destructive">{error}</div> : null}
    </div>
  );
}

export default function RenderModuleForm(props: any) {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <Field label="Module Name">
        <Input
          type="text"
          maxLength={100}
          placeholder="Module Name"
          value={props.moduleName}
          onChange={(e) => {
            const value = e.target.value;
            if (/^[A-Za-z_ ]*$/.test(value)) {
              props.setModuleName(value);
            }
          }}
        />
      </Field>
    </div>
  );
}
